import { render, staticRenderFns } from "./WebviewOcrDialog.vue?vue&type=template&id=4c851109&scoped=true&"
import script from "./WebviewOcrDialog.vue?vue&type=script&lang=js&"
export * from "./WebviewOcrDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c851109",
  null
  
)

export default component.exports